import { pathOr } from 'ramda';
import { useSelector } from 'react-redux';
import { LABELS, META_DATA, OBJECT_META } from 'src/services/constants';
import { ApplicationState } from 'src/store/ApplicationState';
import { buildLabel } from 'src/utilities/naming';
import { authenticatedUser } from 'src/utilities/storage';

export const useLoanApp = () => {
  const loanApp = useSelector(
    (state: ApplicationState) => pathOr({}, ['__resources', 'loanApp', 'data'], state)
  );

  const loanId = pathOr('', ['id'], loanApp);
  const loanType = pathOr('', ['type_of_loan'], loanApp);
  // TODO: once we fixed the migration of property_loan_type to sub_type_of_loan we have use only sub_type_of_loan
  const loanProductType = pathOr('', ['sub_type_of_loan'], loanApp) || 
    pathOr('', ['spec', 'properties', OBJECT_META, LABELS, 'property_loan_type'], loanApp)
    
  const thisTeamId = pathOr('', ['id'], pathOr('', ['spec', 'teams'], loanApp)) || authenticatedUser.teamId.get()
  const loanapp_roles = pathOr([], ['spec', 'loanapp_roles'], loanApp);
  const assigneeEmail = pathOr('', ['spec','loan_status','0',META_DATA,buildLabel('loanapp_assigned_to_advisor_email')], loanApp);
  return {
    loanId,
    loanType,
    loanProductType,
    thisTeamId,
    loanapp_roles,
    loanApp,
    assigneeEmail
  };
};
export default useLoanApp;
